const constants = {
  domainBase: process.env.REACT_APP_DOMAIN_BASE || 'localhost:4000',
  uploadDir: process.env.REACT_APP_STATIC_URL || 'http://localhost:4000',
};

export default constants;
